import React from 'react';
import { Client } from '../../types';

interface ContractStatusProps {
  client: Client;
}

const ContractStatus: React.FC<ContractStatusProps> = ({ client }) => {
  const getStatusBadge = () => {
    if (!client.termsIssued) {
      // Check if this is an existing client
      if (client.isExistingClient) {
        return (
          <span className="px-2 py-1 text-sm font-semibold rounded-full bg-blue-100 text-blue-800">
            Existing Client
          </span>
        );
      }
      return (
        <span className="px-2 py-1 text-sm font-semibold rounded-full bg-gray-100 text-gray-800">
          Not Issued
        </span>
      );
    }
    if (client.termsAccepted) {
      return (
        <span className="px-2 py-1 text-sm font-semibold rounded-full bg-green-100 text-green-800">
          Accepted
        </span>
      );
    }
    if (client.termsDeclined) {
      return (
        <span className="px-2 py-1 text-sm font-semibold rounded-full bg-red-100 text-red-800">
          Declined
        </span>
      );
    }
    
    // Check if we have valid contract token and expiry
    if (client.contractToken && client.contractTokenExpiry) {
      const expiryDate = new Date(client.contractTokenExpiry);
      const currentDate = new Date();
      
      // Ensure both dates are valid before comparison
      if (!isNaN(expiryDate.getTime()) && !isNaN(currentDate.getTime())) {
        if (expiryDate > currentDate) {
          return (
            <span className="px-2 py-1 text-sm font-semibold rounded-full bg-yellow-100 text-yellow-800">
              Pending - Link Active
            </span>
          );
        }
      }
    }
    
    return (
      <span className="px-2 py-1 text-sm font-semibold rounded-full bg-orange-100 text-orange-800">
        Pending - Link Expired
      </span>
    );
  };

  const getTimestamp = () => {
    if (client.termsAccepted && client.acceptedAt) {
      return `Accepted on ${new Date(client.acceptedAt).toLocaleDateString('en-GB')}`;
    }
    if (client.termsDeclined && client.declinedAt) {
      return `Declined on ${new Date(client.declinedAt).toLocaleDateString('en-GB')}`;
    }
    if (client.contractTokenExpiry) {
      const expiryDate = new Date(client.contractTokenExpiry);
      const currentDate = new Date();
      
      // Ensure date is valid before formatting
      if (!isNaN(expiryDate.getTime())) {
        if (expiryDate > currentDate) {
          return `Link expires on ${expiryDate.toLocaleDateString('en-GB')}`;
        }
        return `Link expired on ${expiryDate.toLocaleDateString('en-GB')}`;
      }
    }
    return null;
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <span className="theme-text-primary" style={{ opacity: 0.7 }}>Status:</span>
        {getStatusBadge()}
      </div>
      {getTimestamp() && (
        <div className="flex items-center justify-between">
          <span className="theme-text-primary" style={{ opacity: 0.7 }}>Timeline:</span>
          <span className="text-sm theme-text-primary" style={{ opacity: 0.9 }}>{getTimestamp()}</span>
        </div>
      )}
      {client.declineReason && (
        <div className="mt-4">
          <span className="theme-text-primary" style={{ opacity: 0.7 }}>Decline Reason:</span>
          <p className="mt-1 text-sm theme-text-primary glass-card-light p-3 rounded" style={{ opacity: 0.9 }}>
            {client.declineReason}
          </p>
        </div>
      )}
    </div>
  );
};

export default ContractStatus;
